$(document).ready(function() {
    var href = window.location.href;
    var Rs485Prd = [
        "BZWX0021",
        "BZWX0018",
        "BZWX0015",
        "BZWX0011"
    ];
    var isConnectProBox = false;
    var isRs485PrdPage =
        href.indexOf("/products/") > -1
        && Rs485Prd.indexOf($("span.variant-sku").text()) > -1;
    var isConnectProBox = $("span.variant-sku").text() === "BWMX2000-P";

    if (href.indexOf("/products/") > -1) {
        try {
            // Enable accordion sections in product description with strict validation
            var $description = $(".product__description");
            var children = $description.children();
            var totalSibs = children.length;
            var totalH3 = $(".product__description > h3").length;
            var totalDiv = $(".product__description > div").length;
            
            // Initial count check
            if (totalH3 + totalDiv == totalSibs) {
                // Strict pattern validation: each h3 must be followed by exactly 1 div
                var isValidPattern = true;
                var expectedPairs = 0;
                
                children.each(function(index) {
                    var $this = $(this);
                    if ($this.is('h3')) {
                        expectedPairs++;
                        // Check next sibling exists and is exactly 1 div
                        var $next = children.eq(index + 1);
                        if (!$next.is('div') || children.eq(index + 2).is('div')) {
                            isValidPattern = false;
                            return false; // Break early
                        }
                    }
                });
                
                // Final validation: number of h3 should match expected pairs
                if (isValidPattern && totalH3 === expectedPairs) {
                    $description.accordion({
                        header: function(accordionElement) {
                            return accordionElement.find("h3");
                        }
                    });
                    $description.accordion("enable");
                    
                    // Add smooth scroll functionality
                    $description.on('accordionactivate', function(event, ui) {
                        setTimeout(function() {
                            var $activePanel = ui.newPanel;
                            if ($activePanel.length) {
                                $('html, body').animate({
                                    scrollTop: $activePanel.offset().top - 100
                                }, 300, 'swing');
                            }
                        }, 200);
                    });
                    
                    console.log("Accordion enabled with smooth scroll - " + totalH3 + " sections");
                } else {
                    console.log(`Invalid pattern: ${totalH3} h3, ${totalDiv} div, ${totalSibs} siblings. Each h3 needs exactly 1 following div.`);
                }
            } else {
                console.log(`Uneven counts: ${totalSibs} siblings, ${totalH3} h3, ${totalDiv} div`);
            }
        } catch (e) {
            console.log("Accordion function not available: " + e.message);
        }

        // Target the upsell container for accordion transition and upsell conditions for RS-485 heat pumps
        var prepareAccordionTransition = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    var $container = $('lb-upsell-product-page-addon');        
                    if (!isConnectProBox && $container.length && $('.lb-upsell-ppa-card-cont-list-lt .lb-upsell-product-page-card').length > 3) {
                        $container.each(function() {
                            var $addon = $(this);
                            var $cards = $addon.find('.lb-upsell-ppa-card-cont-list-lt .lb-upsell-ppa-title-cont');
                            
                            $cards.each(function(index) {
                                var $titleCont = $(this);
                                var $contentCards = [];
                                
                                // Collect all following sibling product cards until next title or end
                                var $next = $titleCont.next();
                                while ($next.length && !$next.hasClass('lb-upsell-ppa-card-cont')) {
                                    if ($next.hasClass('lb-upsell-product-page-card')) {
                                        $contentCards.push($next);
                                    }
                                    $next = $next.next();
                                }
                                
                                if ($contentCards.length > 0) {
                                    // Create single h3 with COMPLETE title content restructured
                                    var $h3Title = $titleCont.find('.lb-upsell-ppa-title').first();
                                    var $h4Offer = $titleCont.find('.lb-upsell-ppa-offer-desc').first().detach();
                                    var $smallText = $titleCont.find('small').first().detach();
                                    
                                    // Restructure into single h3 as requested
                                    $h3Title
                                        .append('<br>')
                                        .append($h4Offer.wrap('<span class="offer-desc-wrapper"></span>').parent())
                                        .append('<br>')
                                        .append($smallText);
                                    
                                    // Wrap restructured title in div header
                                    var $header = $('<div class="ui-accordion-header-wrapper"></div>')
                                        .append($titleCont.children()); // Moves perfect h3 structure
                                    var $chevron = $(
                                        '<svg class="accordion-chevron icon icon-caret" aria-hidden="true" viewBox="0 0 10 6">' +
                                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">' +
                                        '</svg>'
                                    );
                                    $header.append($chevron);
                                                                            
                                    // Create accordion content wrapper
                                    var $content = $('<div class="ui-accordion-content"></div>');
                                    $.each($contentCards, function(i, card) {
                                        $content.append($(card));
                                    });
                                    
                                    // Insert accordion structure before original title
                                    $titleCont.before($('<div class="upsell-accordion-' + index + ' ui-accordion"></div>')
                                        .append($header)
                                        .append($content));
                                }
                            });
                            
                            // Initialize all accordions
                            $addon.find('[class*="upsell-accordion"]').accordion({
                                header: '.ui-accordion-header-wrapper', 
                                heightStyle: "content",
                                collapsible: true,
                                active: false
                            });
                        });
                    }
                    if (isRs485PrdPage) {
                        initSellEasyPairedUpsell();
                    }
                },1000,15000
            );
        };
        prepareAccordionTransition('.lb-upsell-ppa-title-cont');
        console.log("Accordion enabled for product addons section");

        // Expands the upsell accordion when some clicks on a description referring link to it
        $(document).on('click', '.upsell-info a[href="#product-form-template--20724230390108__main"], a[id="product-add-ons"]', function () {
            setTimeout(function () {
                var $target = $('.product-form');
                var $accordion = $target.find('.ui-accordion, .your-accordion-selector').first();
                if ($accordion.length && $accordion.accordion('instance')) {  
                    $accordion[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    $accordion.accordion('option', 'active', 0); // opens first panel   
                }    
            }, 400);
        });

        // focus on custom field error when add ot cart fails for that reason
        const fieldObservers = new WeakMap();

        function bindFieldObserver(field) {
            if (!field || fieldObservers.has(field)) return;

            const requiredMsg = field.querySelector('.field-invalid .field-required');
            if (!requiredMsg) return;

            const observer = new MutationObserver(() => {
                const isActive = requiredMsg.classList.contains('active');
                if (!isActive) return;

                requestAnimationFrame(() => {
                    setTimeout(() => {
                        if (!document.body.contains(field)) return;

                        const liveInput = field.querySelector('input, select, textarea');
                        const headerOffset = 180;
                        const top = field.getBoundingClientRect().top + window.pageYOffset - headerOffset;

                        window.scrollTo({
                            top,
                            behavior: 'smooth'
                        });

                        if (liveInput && typeof liveInput.focus === 'function') {
                            liveInput.focus({ preventScroll: true });
                        }
                    }, 100);
                });
            });
            observer.observe(requiredMsg, {
                attributes: true,
                attributeFilter: ['class']
            });
            fieldObservers.set(field, observer);
        }
        function bindAllFields(root) {
            const scope = root || document;
            scope.querySelectorAll('.ma-custom-field').forEach(bindFieldObserver);
        }
        function initContainerObserver() {
            const stableContainer =
            document.querySelector('product-info') ||
            document.querySelector('product-form') ||
            document.querySelector('main') ||
            document.body;

            const containerObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof Element)) return;

                    if (node.matches('.ma-custom-field')) {
                        bindFieldObserver(node);
                    } else if (node.querySelector && node.querySelector('.ma-custom-field')) {
                        bindAllFields(node);
                    }
                    });
                });
            });
            containerObserver.observe(stableContainer, {
            childList: true,
            subtree: true
            });
        }
        bindAllFields();
        initContainerObserver();

        // adjust add to cart button label for out of stock variant, in case required by dedicated variant's metafield value

        function updateComingSoonButton(scope = document) {
            const productForms = scope.querySelectorAll('product-form');

            productForms.forEach((productFormEl) => {
            const form = productFormEl.querySelector('form');
            if (!form) return;

            const variantInput = form.querySelector('input[name="id"]');
            const submitButton = form.querySelector('button[name="add"], button[type="submit"][name="add"]');
            if (!variantInput || !submitButton) return;

            const section = productFormEl.closest('.shopify-section');
            if (!section) return;

            const dataEl = section.querySelector('[id^="VariantComingSoonData-"]');
            if (!dataEl) return;

            let variantLabels = {};
            try {
                variantLabels = JSON.parse(dataEl.textContent);
            } catch (e) {
                return;
            }

            const variantId = String(variantInput.value || '').trim();
            const customLabel = variantLabels[variantId];
            const labelEl =
                submitButton.querySelector('span') ||
                submitButton.querySelector('.product-form__submit-text') ||
                submitButton;

            submitButton.classList.remove('button--coming-soon');
            submitButton.removeAttribute('data-coming-soon');

            if (submitButton.hasAttribute('disabled') && customLabel && String(customLabel).trim() !== '') {
                labelEl.textContent = customLabel;
                submitButton.classList.add('button--coming-soon');
                submitButton.setAttribute('data-coming-soon', 'true');
            }
            });
        }

        document.addEventListener('change', (event) => {
            if (event.target.closest('variant-selects, variant-radios')) {
            setTimeout(() => updateComingSoonButton(document), 200);
            }
        });

        document.addEventListener('shopify:section:load', (event) => {
            updateComingSoonButton(event.target);
        });

        const observer = new MutationObserver(() => {
            // updateComingSoonButton(document);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        updateComingSoonButton(document);

        // uncheck FBT lijmring 50>63 mm by default 

        (function () {
            const skuClassWhitelist = [
                'sku-blfx7525-p',
                'sku-blfx7529-p',
                'sku-bwpx7065-p',
                'sku-bwpx7066-p',
                'sku-bwpx7076-p',
                'sku-bwpx7075-p',
                'sku-zwmx7526-p',
                'sku-zwmx7528-p',
                'sku-zwpx7520-p',
                'sku-zwpx7510-p',
                'sku-bwmx7526-p',
                'sku-bwmx7528-p',
                'sku-zwpx2332-s',
                'sku-zwpx2331-p',
                'sku-belx7050-p',
                'sku-belx7051-p',
                'sku-belx7062-p',
                'sku-belx7061-p',
                'sku-zwpx7660-p',
                'sku-zwpx7550-p',
                'sku-zlax0305-p',
                'sku-zlax0310-p',
                'sku-zlax0315-p',
                'sku-zlax0320-p',
                'sku-zlax0330-p',
                'sku-zlax0331-s',
                'sku-zlax0321-s',
                'sku-zlax0316-s',
                'sku-zlax0311-s',
                'sku-zlax0306-s',
                'sku-zlax0406-p',
                'sku-zlax0411-p',
                'sku-zlax0416-p',
                'sku-zlax0421-p',
                'sku-zlax0431-p',
                'sku-zlax0405-p',
                'sku-zlax0410-p',
                'sku-zlax0415-p',
                'sku-zlax0420-p',
                'sku-zlax0430-p',
                'sku-bwpx7105-p',
                'sku-bwpx7110-p',
                'sku-bwpx7115-p',
                'sku-bwpx7120-p',
                'sku-bwpx7130-p',
                'sku-bwpx7106-p',
                'sku-bwpx7111-p',
                'sku-bwpx7116-p',
                'sku-bwpx7121-p',
                'sku-bwpx7131-p',
                'sku-bwpx7205-p',
                'sku-bwpx7210-p',
                'sku-bwpx7215-p',
                'sku-bwpx7220-p',
                'sku-bwpx7230-p',
                'sku-bwpx7206-p',
                'sku-bwpx7211-p',
                'sku-bwpx7216-p',
                'sku-bwpx7221-p',
                'sku-bwpx7231-p'
            ];

            const shouldApply = () =>
                skuClassWhitelist.some(cls => document.body.classList.contains(cls));

            function uncheckLastFbtItem() {
                if (!shouldApply()) return;

                const checkboxes = Array.from(
                document.querySelectorAll('.ppcse-list-lt-li input[type="checkbox"][id^="boughtTogether"]')
                );

                if (!checkboxes.length) return;

                const checkbox = checkboxes[checkboxes.length - 1];

                if (checkbox.checked) {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            document.addEventListener('DOMContentLoaded', uncheckLastFbtItem);
            window.addEventListener('load', uncheckLastFbtItem);

            const observer = new MutationObserver(() => {
                uncheckLastFbtItem();
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        })()    ;
    }
});

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}

/* SellEasy paired-addon enforcement and popup warning layer */
var initSellEasyPairedUpsell = function () {
    var upsellRoot = document.querySelector('lb-upsell-product-page-addon');
    if (!upsellRoot) return;

    if (upsellRoot.dataset.pairedUpsellInit === 'true') return;
    upsellRoot.dataset.pairedUpsellInit = 'true';

    var checkboxSelector = '.lb-spc-details-checkbox';
    var isInternalUpdate = false;
    var isModalOpen = false;

    var getCheckboxes = function () {
        return Array.prototype.slice.call(
            upsellRoot.querySelectorAll(checkboxSelector),
            0,
            2
        );
    };

    var ensureModalExists = function () {
        if (document.getElementById('paired-upsell-modal')) return;

        var pairedUpsellText = window.PairedUpsellTranslations || {
            title: 'Important notice',
            message_delivery: 'Delivery for this combination may take 1 to 2 weeks and therefore be longer than our standard parcel delivery time.',
            message_bundle: 'Both add-on products must be selected in order to get the Wi-Fi automation enabled.',
            confirm: 'Confirm',
            cancel: 'Cancel'
        };

        var modalHtml = ''
        + '<div id="paired-upsell-modal" class="paired-upsell-modal" aria-hidden="true">'
        + '  <div class="paired-upsell-modal__backdrop" data-paired-upsell-close></div>'
        + '  <div class="paired-upsell-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="paired-upsell-modal-title">'
        + '    <h3 id="paired-upsell-modal-title" class="paired-upsell-modal__title">' + pairedUpsellText.title + '</h3>'
        + '    <div class="paired-upsell-modal__content">'
        + '      <p>' + pairedUpsellText.message_delivery + '</p>'
        + '      <p>' + pairedUpsellText.message_bundle + '</p>'
        + '    </div>'
        + '    <div class="paired-upsell-modal__actions">'
        + '      <button type="button" class="paired-upsell-modal__button paired-upsell-modal__button--secondary" data-paired-upsell-cancel>' + pairedUpsellText.cancel + '</button>'
        + '      <button type="button" class="paired-upsell-modal__button paired-upsell-modal__button--primary" data-paired-upsell-confirm>' + pairedUpsellText.confirm + '</button>'
        + '    </div>'
        + '  </div>'
        + '</div>';
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    };

    var openModal = function (activeCheckbox, otherCheckbox) {
        if (isModalOpen) return;

        ensureModalExists();

        var modal = document.getElementById('paired-upsell-modal');
        var confirmButton = modal.querySelector('[data-paired-upsell-confirm]');
        var cancelButton = modal.querySelector('[data-paired-upsell-cancel]');
        var backdrop = modal.querySelector('[data-paired-upsell-close]');

        if (!modal || !confirmButton || !cancelButton || !backdrop) return;

        isModalOpen = true;
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('paired-upsell-modal-open');

        var cleanup = function () {
            modal.classList.remove('is-active');
            modal.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('paired-upsell-modal-open');

            confirmButton.removeEventListener('click', onConfirm);
            cancelButton.removeEventListener('click', onCancel);
            backdrop.removeEventListener('click', onCancel);
            document.removeEventListener('keydown', onKeydown);

            isModalOpen = false;
        };

        var onConfirm = function () {
            isInternalUpdate = true;

            if (!activeCheckbox.checked) {
                activeCheckbox.checked = true;
                activeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }

            if (otherCheckbox && !otherCheckbox.checked) {
                otherCheckbox.checked = true;
                otherCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }

            isInternalUpdate = false;
            cleanup();
        };

        var onCancel = function () {
            isInternalUpdate = true;
            activeCheckbox.checked = false;
            activeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            isInternalUpdate = false;
            cleanup();
        };

        var onKeydown = function (event) {
            if (event.key === 'Escape') {
                onCancel();
            }
        };

        confirmButton.addEventListener('click', onConfirm);
        cancelButton.addEventListener('click', onCancel);
        backdrop.addEventListener('click', onCancel);
        document.addEventListener('keydown', onKeydown);
    };

    var bindCheckboxes = function () {
        var checkboxes = getCheckboxes();
        if (checkboxes.length < 2) return;

        checkboxes.forEach(function (checkbox, index) {
            if (checkbox.dataset.pairedUpsellBound === 'true') return;
            checkbox.dataset.pairedUpsellBound = 'true';

            checkbox.addEventListener('change', function (event) {
                if (isInternalUpdate) return;

                var currentCheckbox = event.currentTarget;
                var otherCheckbox = checkboxes[index === 0 ? 1 : 0];

                if (currentCheckbox.checked && otherCheckbox && !otherCheckbox.checked) {
                    openModal(currentCheckbox, otherCheckbox);
                }
            });
        });
    };

    bindCheckboxes();

    var observer = new MutationObserver(function () {
        bindCheckboxes();
    });

    observer.observe(upsellRoot, {
        childList: true,
        subtree: true
    });
};